import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Col, DatePicker, Form, Input, Radio, Row } from 'antd';
import { CurrentUserStore } from 'stores';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const ServiceFeedback = ({ setFeedbackValue, setCompletedTime }) => {
  const [form] = Form.useForm();
  const [textArea, setTextArea] = useState('');
  const [currentSelectedOption, setCurrentSelectedOption] = useState('');

  useEffect(() => {
    if (textArea && currentSelectedOption) {
      setFeedbackValue(`${currentSelectedOption} - ${textArea}`);
    } else if (textArea) {
      setFeedbackValue(textArea);
    } else {
      setFeedbackValue(currentSelectedOption);
    }
  }, [textArea, currentSelectedOption, setFeedbackValue]);

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  return (
    <Form form={form} layout="vertical">
      <Row>
        <Col span={24}>
          <Form.Item
            label="Service is completed on:"
            name="completedTime"
            initialValue={dayjs()}
            rules={[{ required: true, message: 'Please select a date!' }]}
          >
            <DatePicker
              showTime
              placeholder="Select Time"
              onChange={(val) => {
                if (val) {
                  setCompletedTime(
                    dayjs
                      .tz(val, CurrentUserStore.user.settings.timezone)
                      .toISOString()
                  );
                } else {
                  setCompletedTime(null);
                }
              }}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item name="feedbackOption">
            <Radio.Group
              onChange={(e) => {
                setCurrentSelectedOption(e.target.value);
              }}
            >
              <Radio
                style={radioStyle}
                value="We performed service on this issue"
              >
                We performed service on this issue
              </Radio>
              <Radio
                style={radioStyle}
                value="The issue existed but can be ignored"
              >
                The issue existed but can be ignored
              </Radio>
              <Radio
                style={radioStyle}
                value="The issue did not exist and this alert is false"
              >
                The issue did not exist and this alert is false
              </Radio>
              <Radio
                style={radioStyle}
                value="The alert is outdated and no longer relevant"
              >
                The alert is outdated and no longer relevant
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="Can you tell us a little more?" name="moreInfo">
            <Input.TextArea
              rows={5}
              placeholder="The more details that are shared allows the Pitstop algorithms to get smarter and more accurate"
              onChange={(e) => {
                setTextArea(e.target.value);
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

ServiceFeedback.propTypes = {
  setFeedbackValue: PropTypes.func.isRequired,
  setCompletedTime: PropTypes.func.isRequired,
};

ServiceFeedback.defaultProps = {
  setFeedbackValue: () => {},
  setCompletedTime: () => {},
};

export default ServiceFeedback;
